import styled from 'styled-components';
import IconArrowDownCircle from './IconArrowDownCircle';
var IconArrowLeftCircle = /*#__PURE__*/styled(IconArrowDownCircle).withConfig({
  displayName: "IconArrowLeftCircle",
  componentId: "c11n-8-111-1__sc-lv8gxv-0"
})(["transform:rotate(90deg);"]);
export default IconArrowLeftCircle;